// Token 相关的常量
const TOKEN_KEY = 'Admin-Token'
const USER_INFO_KEY = 'User-Info'

// 获取 token
export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

// 设置 token
export function setToken(token) {
  return localStorage.setItem(TOKEN_KEY, token)
}

// 移除 token
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_INFO_KEY)
}

// 获取用户信息
export function getUserInfo() {
  const userInfo = localStorage.getItem(USER_INFO_KEY)
  return userInfo ? JSON.parse(userInfo) : null
}

// 设置用户信息
export function setUserInfo(userInfo) {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
}

// 检查是否已登录
export function isLoggedIn() {
  return !!getToken()
}

// 清除所有认证相关的数据
export function clearAuth() {
  removeToken()
  localStorage.removeItem(USER_INFO_KEY)
}

export default {
  getToken,
  setToken,
  removeToken,
  getUserInfo,
  setUserInfo,
  isLoggedIn,
  clearAuth
} 